module.exports = __webpack_public_path__ + "img/32.78b9db1e.png";